export const FETCH_BRANCH_REQUEST="FETCH_BRANCH_REQUEST"
export const FETCH_BRANCH_SUCCESS="FETCH_BRANCH_SUCCESS"
export const FETCH_BRANCH_FAIL="FETCH_BRANCH_FAIL"